import { createContext, type ReactNode, useContext, useState } from "react";
import { matchPath, useLocation } from "react-router";
import ActoRoutes from "@acto/taskpane/core/router/routes.config";

const ReturnOriginContext = createContext<string | null>(null);

export function ReturnOriginProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [origin] = useState(() => (location.state as { from?: string } | undefined)?.from ?? ActoRoutes.HOME);

  return <ReturnOriginContext.Provider value={origin}>{children}</ReturnOriginContext.Provider>;
}

export function useReturnOrigin(): string {
  return useContext(ReturnOriginContext) ?? ActoRoutes.HOME;
}

/** True when the captured return origin is a corporate-group view. */
export function useIsFromGroupView(): boolean {
  const origin = useReturnOrigin();
  return matchPath(ActoRoutes.CUSTOMER_GROUP, origin.split("?")[0]) != null;
}
